export const SWIM_STROKES = [
    "Crawl",
    "Costas",
    "Peito",
    "Borboleta",
    "Livre",
    "Medley",
    "Perna",
    "Braço",
    "Educativo",
];

export const SWIM_INTENSITY_ZONES = [
    "A1",
    "A2",
    "A3",
    "AN",
    "VO2",
    "Máximo",
    "Leve",
    "Moderado",
    "Forte",
];

export const SWIM_SET_TYPES = [
    "Aquecimento",
    "Educativo",
    "Técnica",
    "Principal",
    "Velocidade",
    "Soltura",
    "Teste",
];

export const SWIM_EQUIPMENT_OPTIONS = [
    "Sem material",
    "Prancha",
    "Pull buoy",
    "Palmar",
    "Nadadeira",
    "Snorkel",
    "Elástico",
    "Paraquedas",
    "Cinto de tração",
    "Tubo frontal",
];

export const SWIM_BLOCK_NAMES = [
    "Aquecimento",
    "Principal",
    "Soltura",
    "Educativo",
    "Técnica",
    "Velocidade",
    "Resistência",
    "Livre",
];

export const DEFAULT_SWIM_SET = {
    reps: 1,
    distance: 50,
    setType: "Principal",
    style: "",
    intensity: "",
    interval: "",
    equipment: "",
    technicalFocus: "",
    description: "",
};
